/**
 * @generated SignedSource<<c6f0f4b3fdf36a8ce9fa133d1ccd7cc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HeaderContentCurrentViewFragment$data = {
  readonly description: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EditViewButtonCurrentViewFragment" | "IconAndColorPickerViewFragment">;
  readonly " $fragmentType": "HeaderContentCurrentViewFragment";
};
export type HeaderContentCurrentViewFragment$key = {
  readonly " $data"?: HeaderContentCurrentViewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderContentCurrentViewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderContentCurrentViewFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IconAndColorPickerViewFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditViewButtonCurrentViewFragment"
    }
  ],
  "type": "Shortcutable",
  "abstractKey": "__isShortcutable"
};

(node as any).hash = "388f84391a3d674c2c06c71681bb4b79";

export default node;
